import { render, staticRenderFns } from "./viewCustomer.vue?vue&type=template&id=1842241f&scoped=true&"
import script from "./viewCustomer.vue?vue&type=script&lang=js&"
export * from "./viewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./viewCustomer.vue?vue&type=style&index=0&id=1842241f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842241f",
  null
  
)

export default component.exports